require('./OKLayoutMigration.scss');

// @vendor
import PropTypes from 'prop-types';

// @components
import { Header } from '../header/header.component';
import { OKButton } from 'commonsComponents/OKButton';

export const OKLayoutMigration = ({ children, header, footer }) => {
  return (
    <div className="ok-layout-migration">
      <Header
        leftSideText={header ? header.leftSideText : ''}
        exitButton={header && header.exitButton}
      />
      <div
        className={`ok-layout-migration__container ${
          header && header.leftSideText ? 'ok-layout-migration__container-with-text' : ''
        }`}
      >
        {children}
        {footer && (
          <div
            className={`ok-layout-migration__footer-navigation ${
              footer.smallMarginTop ? 'ok-layout-migration__footer-navigation-small-margin' : ''
            }`}
          >
            {!!footer.leftSideLink && (
              <div className="ok-layout-migration__footer-navigation--left">
                <OKButton
                  modifier="link-ghost"
                  onClick={footer.leftSideLink.handler}
                  disabled={footer.leftSideLink.disabled}
                >
                  <strong>{footer.leftSideLink.text} </strong>
                </OKButton>
              </div>
            )}
            {!!footer.rightSideButton && (
              <div
                className={`ok-layout-migration__footer-navigation--right ${
                  !!footer.leftSideLink ? '' : 'small-margin-bottom'
                }`}
              >
                <OKButton
                  loading={footer.rightSideButton.loading}
                  disabled={footer.rightSideButton.disabled}
                  modifier={footer.rightSideButton.modifier || 'primary'}
                  onClick={footer.rightSideButton.handler}
                >
                  <strong>{footer.rightSideButton.text}</strong>
                </OKButton>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

OKLayoutMigration.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.shape({
    leftSideText: PropTypes.string,
    exitButton: PropTypes.shape({
      handleClickButton: PropTypes.func,
    }),
  }),
  footer: PropTypes.shape({
    leftSideLink: PropTypes.shape({
      text: PropTypes.string,
      handler: PropTypes.func,
    }),
    rightSideButton: PropTypes.shape({
      loading: PropTypes.bool,
      disabled: PropTypes.bool,
      text: PropTypes.string,
      handler: PropTypes.func,
      modifier: PropTypes.string,
    }),
  }),
};
